import { Select, styled } from '@mui/material';

export const StyledSelect = styled(Select)`
  height: 36px;
  &.MuiInput-underline:before,
  &.MuiInput-underline:after {
    display: none;
  }
`;
